// Generated by scripts/make-pet-insurance-mock.js from clipboard on 2026-09-22.
// Regenerate it with the script instead of editing it by hand.
import { PetInsuranceData } from "../models";

export const getAllMock = [
  {
    "pet_name": "Test multipet2",
    "pet_species": "dog",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "mischling_gross",
    "birthdate": "2024-09-03T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000920-1664",
    "contract_number": "20000920",
    "base_number": "20000920",
    "customer_id": 10000556,
    "status": "policiert",
    "start_date": "2026-04-23",
    "end_date": "2027-04-22",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 562.7685,
    "yearly_gross_premium_pro_rata": 562.7685,
    "yearly_net_premium": 377.2,
    "payment_interval": "jährlich",
    "taxes": 26.798500000000004,
    "product_bundle": "L",
    "yearly_net_premium_base": 535.97,
    "annual_franchise": 500,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 12000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2000,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "23.04.2026",
        "invoiceNumber": "3124",
        "dueDate": "23.04.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 562.75,
        "openAmount": 562.75,
        "bookingDate": "23.04.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-03124",
        "bexio_network_link": "https://network.bexio.com/invoice/c29b1dedbe5b81fcb4d744ff7c2ac380fe298cac2ce528dc640e3a2e0db88220",
        "bexio_invoice_id": "3124",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Test multipet3",
    "pet_species": "cat",
    "pet_gender": "female",
    "breed_type": true,
    "breed": "american_bobtail",
    "birthdate": "2024-12-05T00:00:00Z",
    "neutered": true,
    "housecat": true,
    "full_contract_number": "20000919-1663",
    "contract_number": "20000919",
    "base_number": "20000919",
    "customer_id": 10000556,
    "status": "gekündigt",
    "start_date": "2026-04-23",
    "end_date": "2027-04-22",
    "cancellation_date": "2026-05-22",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 325.9725,
    "yearly_gross_premium_pro_rata": 325.9725,
    "yearly_net_premium": 195.65,
    "payment_interval": "jährlich",
    "taxes": 15.5225,
    "product_bundle": "L",
    "yearly_net_premium_base": 310.45,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 12000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2000,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "23.04.2026",
        "invoiceNumber": "3123",
        "dueDate": "23.04.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 325.95,
        "openAmount": 325.95,
        "bookingDate": "23.04.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-03123",
        "bexio_network_link": "https://network.bexio.com/invoice/70673a410a53d0622514376add0606bc29c3f88a68f2536758853196ad3c04f7",
        "bexio_invoice_id": "3123",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Test multipet1",
    "pet_species": "cat",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "mischlingskatze",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000917-1661",
    "contract_number": "20000917",
    "base_number": "20000917",
    "customer_id": 10000556,
    "status": "policiert",
    "start_date": "2026-04-23",
    "end_date": "2027-04-22",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 498.8025,
    "yearly_gross_premium_pro_rata": 498.8025,
    "yearly_net_premium": 195.65,
    "payment_interval": "jährlich",
    "taxes": 23.7525,
    "product_bundle": "L",
    "yearly_net_premium_base": 475.05,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 12000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2000,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "23.04.2026",
        "invoiceNumber": "3121",
        "dueDate": "23.04.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 498.8,
        "openAmount": 498.8,
        "bookingDate": "23.04.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-03121",
        "bexio_network_link": "https://network.bexio.com/invoice/a6cd25d6dc9fed6cfa1da9d237d5604ddea35a61cc00e1e47bf86f10ada45ea8",
        "bexio_invoice_id": "3121",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Quatro",
    "pet_species": "cat",
    "pet_gender": "female",
    "breed_type": false,
    "breed": "mischlingskatze",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000895-1619",
    "contract_number": "20000895",
    "base_number": "20000895",
    "customer_id": 10000556,
    "status": "policiert",
    "start_date": "2026-03-30",
    "end_date": "2027-03-29",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 456.27750000000003,
    "yearly_gross_premium_pro_rata": 114.069375,
    "yearly_net_premium": 185.48,
    "payment_interval": "quartalsweise",
    "taxes": 21.727500000000003,
    "product_bundle": "M",
    "yearly_net_premium_base": 434.55,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 0,
    "deductible_percentage_after_9_years": 0,
    "overall_sum_insured": 6000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": false
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [
      {
        "identifier": "100723",
        "claim_date": "2026-06-18T00:00:00Z",
        "notification_date": "2026-06-18T00:00:00Z",
        "paid_amount": 0,
        "expense": 80.95,
        "used_franchsie": 80.95,
        "status": "Geschlossen",
        "closing_reason": "Approved",
        "closing_date": "2026-07-16T00:00:00Z",
        "type": "Krankheit",
        "sub_type": "Allgemeine Tieraerztliche Behandlung",
        "cause": "Ohrentzündung",
        "insured_event": false,
        "reason_why_not_insured": "",
        "deduction_yearly_franchise": 80.95,
        "deduction_percentage_deductible": 0,
        "deduction_deductible": 0,
        "deduction_non_covered_positions": 0,
        "deduction_discount": 0,
        "deduction_others": 0,
        "benefit_amount": 80.95,
        "precedent_claim_id": "",
        "fnolRequestId": "27936ed0-fa6a-42a6-89b4-66a93975ee95",
        "invoiceDocument": {
          "s3Id": "D7zQ_000_example_invoice_agent.pdf"
        }
      }
    ],
    "invoices": [
      {
        "dateCreated": "10.04.2026",
        "invoiceNumber": "2955",
        "dueDate": "10.04.2026",
        "paymentStatus": "PAID",
        "totalAmount": 114.1,
        "openAmount": 0,
        "bookingDate": "26.05.2026",
        "referenceNumber": "",
        "invoiceStatus": "PAID",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02955",
        "bexio_network_link": "https://network.bexio.com/invoice/990428c0bba796891409540a0b6e4f2782cf8629b5e0f0878c651975fec23495",
        "bexio_invoice_id": "2955",
        "bexio_pdf_available": true
      },
      {
        "dateCreated": "17.07.2026",
        "invoiceNumber": "3566",
        "dueDate": "17.07.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 114.1,
        "openAmount": 114.1,
        "bookingDate": "17.07.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-03566",
        "bexio_network_link": "https://network.bexio.com/invoice/36935b9a6f0ca10b49913a34fd8c5aa8def63183498281f20ee1c7014b2af98d",
        "bexio_invoice_id": "3566",
        "bexio_pdf_available": true
      },
      {
        "dateCreated": "30.09.2026",
        "invoiceNumber": "4110",
        "dueDate": "30.09.2026",
        "paymentStatus": "FUTURE",
        "totalAmount": 114.1,
        "openAmount": 114.1,
        "bookingDate": "30.09.2026",
        "referenceNumber": "",
        "invoiceStatus": "FUTURE",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-04110",
        "bexio_network_link": "https://network.bexio.com/invoice/cdcc39ad0a7cb49591d43b910a49ce1578bd08426a78d878781a9c2aaf0345e6",
        "bexio_invoice_id": "4110",
        "bexio_pdf_available": true
      },
      {
        "dateCreated": "30.12.2026",
        "invoiceNumber": "",
        "dueDate": "30.12.2026",
        "paymentStatus": "FUTURE",
        "totalAmount": 114.1,
        "openAmount": 114.1,
        "bookingDate": "",
        "referenceNumber": "",
        "invoiceStatus": "FUTURE",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_pdf_available": false
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Bruno",
    "pet_species": "cat",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "mischlingskatze",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000892-1616",
    "contract_number": "20000892",
    "base_number": "20000892",
    "customer_id": 10000556,
    "status": "policiert",
    "start_date": "2026-03-30",
    "end_date": "2027-03-29",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 470.379,
    "yearly_gross_premium_pro_rata": 470.3790000000001,
    "yearly_net_premium": 185.48,
    "payment_interval": "jährlich",
    "taxes": 22.399,
    "product_bundle": "M",
    "yearly_net_premium_base": 447.98,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 6000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": false
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [
      {
        "identifier": "100581",
        "claim_date": "2026-03-31T00:00:00Z",
        "notification_date": "2026-03-31T00:00:00Z",
        "paid_amount": 0,
        "expense": 0,
        "used_franchsie": 0,
        "status": "Offen",
        "closing_reason": "",
        "closing_date": "",
        "type": "Notfallbetreuung",
        "sub_type": "",
        "cause": "",
        "insured_event": false,
        "reason_why_not_insured": "",
        "deduction_yearly_franchise": 0,
        "deduction_percentage_deductible": 0,
        "deduction_deductible": 0,
        "deduction_non_covered_positions": 0,
        "deduction_discount": 0,
        "deduction_others": 0,
        "benefit_amount": 0,
        "precedent_claim_id": "",
        "fnolRequestId": "test",
        "invoiceDocument": null
      },
      {
        "identifier": "100582",
        "claim_date": "2026-03-31T00:00:00Z",
        "notification_date": "2026-03-31T00:00:00Z",
        "paid_amount": 0,
        "expense": 0,
        "used_franchsie": 0,
        "status": "Offen",
        "closing_reason": "",
        "closing_date": "",
        "type": "Krankheit",
        "sub_type": "Verhaltensmedizinische Behandlung",
        "cause": "Verhaltensstörung",
        "insured_event": false,
        "reason_why_not_insured": "",
        "deduction_yearly_franchise": 0,
        "deduction_percentage_deductible": 0,
        "deduction_deductible": 0,
        "deduction_non_covered_positions": 0,
        "deduction_discount": 0,
        "deduction_others": 0,
        "benefit_amount": 0,
        "precedent_claim_id": "",
        "fnolRequestId": "9eb12923-7180-425c-ad13-36433fda5882",
        "invoiceDocument": {
          "s3Id": "RTEH_test1.pdf"
        }
      },
      {
        "identifier": "100661",
        "claim_date": "2025-06-09T00:00:00Z",
        "notification_date": "2025-06-09T00:00:00Z",
        "paid_amount": 0,
        "expense": 0,
        "used_franchsie": 0,
        "status": "Offen",
        "closing_reason": "",
        "closing_date": "",
        "type": "Praevention",
        "sub_type": "",
        "cause": "",
        "insured_event": false,
        "reason_why_not_insured": "",
        "deduction_yearly_franchise": 0,
        "deduction_percentage_deductible": 0,
        "deduction_deductible": 0,
        "deduction_non_covered_positions": 0,
        "deduction_discount": 0,
        "deduction_others": 0,
        "benefit_amount": 0,
        "precedent_claim_id": "",
        "fnolRequestId": "test",
        "invoiceDocument": null
      }
    ],
    "invoices": [
      {
        "dateCreated": "10.04.2026",
        "invoiceNumber": "2953",
        "dueDate": "10.04.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 470.4,
        "openAmount": 470.4,
        "bookingDate": "10.04.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02953",
        "bexio_network_link": "https://network.bexio.com/invoice/c3418b19cdf575e9cf3669e7e6e1ffe62937cc10ce0e95dd99deef85091e8e5f",
        "bexio_invoice_id": "2953",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Bruno",
    "pet_species": "cat",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "mischlingskatze",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000891-1615",
    "contract_number": "20000891",
    "base_number": "20000891",
    "customer_id": 10000556,
    "status": "gekündigt",
    "start_date": "2026-03-30",
    "end_date": "2027-03-29",
    "cancellation_date": "2026-08-19",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 470.379,
    "yearly_gross_premium_pro_rata": 470.3790000000001,
    "yearly_net_premium": 185.48,
    "payment_interval": "jährlich",
    "taxes": 22.399,
    "product_bundle": "M",
    "yearly_net_premium_base": 447.98,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 6000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": false
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "09/04/2026",
        "invoiceNumber": "2949",
        "dueDate": "09/04/2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 470.4,
        "openAmount": 470.4,
        "bookingDate": "09/04/2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02949",
        "bexio_network_link": "https://network.bexio.com/invoice/2a0d792ab75dc38f40a05f677f16f4c7e6708501b6c646fada24e27d6c3818eb",
        "bexio_invoice_id": "2949",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Bello",
    "pet_species": "dog",
    "pet_gender": "female",
    "breed_type": true,
    "breed": "airedale_terrier",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000890-1614",
    "contract_number": "20000890",
    "base_number": "20000890",
    "customer_id": 10000556,
    "status": "gekündigt",
    "start_date": "2026-03-30",
    "end_date": "2027-03-29",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 590.3205,
    "yearly_gross_premium_pro_rata": 590.3205,
    "yearly_net_premium": 353.2,
    "payment_interval": "jährlich",
    "taxes": 28.110500000000002,
    "product_bundle": "M",
    "yearly_net_premium_base": 562.21,
    "annual_franchise": 500,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 6000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": false
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "09.04.2026",
        "invoiceNumber": "2946",
        "dueDate": "09.04.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 590.3,
        "openAmount": 590.3,
        "bookingDate": "09.04.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02946",
        "bexio_network_link": "https://network.bexio.com/invoice/e9b0569e47e1e8f1071e2451c3c6583657cb2437e81c8784b0703abb63c5cd3b",
        "bexio_invoice_id": "2946",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "F",
    "pet_species": "dog",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "hollandischer_rattler",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000889-1613",
    "contract_number": "20000889",
    "base_number": "20000889",
    "customer_id": 10000556,
    "status": "gekündigt",
    "start_date": "2026-03-30",
    "end_date": "2027-03-29",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 709.527,
    "yearly_gross_premium_pro_rata": 709.527,
    "yearly_net_premium": 377.2,
    "payment_interval": "jährlich",
    "taxes": 33.787,
    "product_bundle": "L",
    "yearly_net_premium_base": 675.74,
    "annual_franchise": 500,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 12000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 12000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 2000,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "09.04.2026",
        "invoiceNumber": "2947",
        "dueDate": "09.04.2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 709.55,
        "openAmount": 709.55,
        "bookingDate": "09.04.2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02947",
        "bexio_network_link": "https://network.bexio.com/invoice/294236b8b7731401b0036693ef075c72ff8ae10eb7aec70ec480e29ba735a3fd",
        "bexio_invoice_id": "2947",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Bruno",
    "pet_species": "cat",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "mischlingskatze",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000766-1378",
    "contract_number": "20000766",
    "base_number": "20000766",
    "customer_id": 10000556,
    "status": "gekündigt",
    "start_date": "2026-01-16",
    "end_date": "2027-01-15",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 470.379,
    "yearly_gross_premium_pro_rata": 470.3790000000001,
    "yearly_net_premium": 185.48,
    "payment_interval": "jährlich",
    "taxes": 22.399,
    "product_bundle": "M",
    "yearly_net_premium_base": 447.98,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 6000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": false
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "16/01/2026",
        "invoiceNumber": "2373",
        "dueDate": "16/01/2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 470.4,
        "openAmount": 470.4,
        "bookingDate": "16/01/2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02373",
        "bexio_network_link": "https://network.bexio.com/invoice/b06fb8d0aba9108671c03b24b784999e481bbe47f8f5deaf0858ccb0dd5d7c50",
        "bexio_invoice_id": "2373",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  },
  {
    "pet_name": "Bruno",
    "pet_species": "cat",
    "pet_gender": "male",
    "breed_type": false,
    "breed": "mischlingskatze",
    "birthdate": "2021-04-12T00:00:00Z",
    "neutered": true,
    "housecat": false,
    "full_contract_number": "20000758-1362",
    "contract_number": "20000758",
    "base_number": "20000758",
    "customer_id": 10000556,
    "status": "gekündigt",
    "start_date": "2026-01-09",
    "end_date": "2027-01-08",
    "cancellation_date": "",
    "date_of_wish_to_cancel": "",
    "yearly_gross_premium": 470.379,
    "yearly_gross_premium_pro_rata": 470.3790000000001,
    "yearly_net_premium": 185.48,
    "payment_interval": "jährlich",
    "taxes": 22.399,
    "product_bundle": "M",
    "yearly_net_premium_base": 447.98,
    "annual_franchise": 300,
    "deductible_percentage_until_9_years": 20,
    "deductible_percentage_after_9_years": 20,
    "overall_sum_insured": 6000,
    "accident_and_illness_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_advanced_treatment_coverage": {
      "coverage_selected": false
    },
    "illness_complementary_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "illness_behavioural_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "accident_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "illness_dental_treatment_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 6000,
      "sublimit_percentage": -1
    },
    "emergency_minding_coverage": {
      "coverage_selected": true,
      "sublimit_sum": 1500,
      "sublimit_percentage": -1
    },
    "emergency_treatment_coverage": {
      "coverage_selected": false
    },
    "medical_food_coverage": {
      "coverage_selected": false
    },
    "preventive_care_coverage": {
      "coverage_selected": false
    },
    "preexisting_conditions_coverage": {
      "yearly_net_premium": 0,
      "sum_insured_current_year": 0,
      "preexisting_conditions": false
    },
    "worldwide_protection_coverage": {
      "yearly_net_premium": 0,
      "sum_insured": 2500,
      "worldwide_protection": true
    },
    "lang": "DE",
    "german_salutation": "Herr",
    "firstname": "Dev",
    "lastname": "Stefantsov-T",
    "parent_birthdate": "1990-01-01",
    "street": "Avenue d'Ouchh",
    "house_number": "922",
    "zip": "8887",
    "city": "Plonss",
    "country": "CH",
    "claims": [],
    "invoices": [
      {
        "dateCreated": "09/01/2026",
        "invoiceNumber": "2308",
        "dueDate": "09/01/2026",
        "paymentStatus": "OUTSTANDING",
        "totalAmount": 470.4,
        "openAmount": 470.4,
        "bookingDate": "09/01/2026",
        "referenceNumber": "",
        "invoiceStatus": "OUTSTANDING",
        "reminderDate": "",
        "firstDunningDate": "",
        "secondDunningDate": "",
        "suspensionDate": "",
        "sumPremiumAccount": 0,
        "bexio_document_nr": "Calingo-Pet-02308",
        "bexio_network_link": "https://network.bexio.com/invoice/a112967aee2b39fa24e615021ee53bf64d16c4ae513aabd0de345a9ea2eab4c6",
        "bexio_invoice_id": "2308",
        "bexio_pdf_available": true
      }
    ],
    "phone_number": "+41791234569"
  }
] as unknown as PetInsuranceData[];
